<template>
  <button :type="type" :disabled="disabled" :class="[base, variantClass, sizeClass, className]" @click="$emit('click', $event)">
    <slot />
  </button>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    type: { type: String, default: 'button' },
    disabled: { type: Boolean, default: false },
    variant: { type: String, default: 'default' },
    size: { type: String, default: 'default' },
    className: { type: String, default: '' },
  },
  computed: {
    base() {
      return 'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors disabled:pointer-events-none disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ring-offset-background'
    },
    variantClass() {
      const v = this.variant
      if (v === 'outline') return 'border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground'
      if (v === 'secondary') return 'bg-secondary text-secondary-foreground hover:bg-secondary/80'
      if (v === 'ghost') return 'hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50'
      if (v === 'link') return 'text-primary underline-offset-4 hover:underline'
      if (v === 'destructive') return 'bg-destructive text-white hover:bg-destructive/90'
      return 'bg-primary text-primary-foreground hover:bg-primary/90'
    },
    sizeClass() {
      const s = this.size
      if (s === 'sm') return 'h-8 rounded-md gap-1.5 px-3'
      if (s === 'lg') return 'h-10 rounded-md px-6'
      if (s === 'icon') return 'h-9 w-9'
      return 'h-9 px-4 py-2'
    },
  },
}
</script>

